import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { DefaultSession, TrackingType } from '@sajari/sdk-js';
import { Tracking } from './Tracking.esm.js';
import { getTrackingData } from './utils.esm.js';

var NoTracking = /*#__PURE__*/function (_Tracking) {
  _inheritsLoose(NoTracking, _Tracking);

  function NoTracking() {
    var _this;

    _this = _Tracking.call(this, '_id') || this;
    _this.clientTracking = new DefaultSession(TrackingType.None, _this.field, getTrackingData());
    return _this;
  }

  return NoTracking;
}(Tracking);

export { NoTracking };
//# sourceMappingURL=NoTracking.esm.js.map
